module.exports = __webpack_public_path__ + "img/zibal.c2e3d8a7.svg";